import { Link } from 'react-router-dom';
import type { Locale } from '../../app/locale/resolveLocale';

const guideCopy: Record<Locale, {
  brand: string;
  title: string;
  intro: string;
  disclaimer: string;
  steps: Array<{ label: string; title: string; body: string }>;
  start: string;
  types: string;
  typesHref: string;
}> = {
  'zh-CN': {
    brand: '社交事故局',
    title: '社交事故局怎么玩？',
    intro: '每道题先记录你的第一反应，再记录后续选择，最后生成一份社交事故档案。',
    disclaimer: '这是娱乐向社交人格内容，不是临床、心理诊断或科学测评。',
    steps: [
      {
        label: '01',
        title: '先看社交现场',
        body: '题目来自聊天、群聊、边界、冲突、冷场和补救场景。'
      },
      {
        label: '02',
        title: '用手势交出第一反应',
        body: '上滑、下滑、左右滑、长按、双击、摇一摇和停顿都会变成弱信号。'
      },
      {
        label: '03',
        title: '再选一句后续处理',
        body: '系统会综合回避、直率、修复、边界、控场和玩梗防御等维度。'
      }
    ],
    start: '开始测试',
    types: '查看人格图鉴',
    typesHref: '/zh/types/'
  },
  en: {
    brand: 'Social Reflex',
    title: 'How Social Reflex Works',
    intro: 'Each scene records your first reaction, then your follow-up choice, and turns the pattern into a Social Mishap Report.',
    disclaimer: 'This is entertainment-style personality content, not a clinical, psychological, or scientific assessment.',
    steps: [
      {
        label: '01',
        title: 'Read the social moment',
        body: 'Scenes cover chat, groups, boundaries, conflict, awkward silence, and repair moments.'
      },
      {
        label: '02',
        title: 'React with a gesture',
        body: 'Swipes, holds, double taps, shakes, flings, and hesitation become weak behavior signals.'
      },
      {
        label: '03',
        title: 'Choose the follow-up',
        body: 'The result combines avoidance, directness, repair, boundaries, control, and meme defense.'
      }
    ],
    start: 'Start test',
    types: 'Browse types',
    typesHref: '/en/types/'
  }
};

export function HowItWorksPage({ locale }: { locale: Locale }) {
  const copy = guideCopy[locale];

  return (
    <main className="how-it-works-page">
      <section className="how-it-works-hero">
        <div className="how-it-works-copy">
          <p className="landing-kicker">{copy.brand}</p>
          <h1>{copy.title}</h1>
          <p>{copy.intro}</p>
          <p className="guide-disclaimer">{copy.disclaimer}</p>
          <div className="landing-actions">
            <Link className="primary-link" to="/play">{copy.start}</Link>
            <a className="secondary-link" href={copy.typesHref}>{copy.types}</a>
          </div>
        </div>
        <div className="guide-step-list" aria-label={locale === 'zh-CN' ? '玩法步骤' : 'How it works steps'}>
          {copy.steps.map((step) => (
            <article className="guide-step" key={step.label}>
              <span>{step.label}</span>
              <h2>{step.title}</h2>
              <p>{step.body}</p>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}
